import { useRouter } from 'next/router'

export const useProfileId = (profileId?: string): string | undefined => {
  const router = useRouter()
  return (router?.query?.id as string) ?? profileId
}
